import { DI } from '@intigral/constant/config/DIContainer';
import { Container } from '../../../DIContainer';
import { AddDeviceUseCase } from './AddDeviceUseCase';
import { DeleteDeviceUseCase } from './DeleteDeviceUseCase';
import { GetDeviceUseCase } from './GetDeviceUseCase';

export const initializeDeviceUseCases = (container: Container) => {
    container.register(DI.USECASES.IAddDeviceUseCase, {
        useClass: AddDeviceUseCase,
    });
    container.register(DI.USECASES.IDeleteDeviceUseCase, {
        useClass: DeleteDeviceUseCase,
    });
    container.register(DI.USECASES.IGetDevicesUseCase, {
        useClass: GetDeviceUseCase,
    });
};
